import { formatProduct, formatUrl } from '~/format/format-product'

/**
 * Formats response from predictive search results.
 * @param {Object} response - GraphQL response.
 * @returns {Object}
 */
export function formatPredictiveSearchResults(response) {
  const results = response.predictiveSearch

  const formattedResults = {
    articles: results?.articles,
    pages: results?.pages,
    queries: results?.queries,
  }

  formattedResults.collections = results?.collections
    .map((item) => ({
      ...item,
      url: formatUrl(
        `//${location.host}${cnvs.routes.normalisedRoot}collections/${item.handle}`,
        null,
      ),
    }))

  formattedResults.products = results.products
    .map((item) => formatProduct(item))
    .filter((product) => {
      if (!window.cnvs?.customer?.isB2b) {
        return true
      }

      return product.variants.some((variant) => variant.isB2bSaleable !== false)
    })

  return formattedResults
}
